import React, { useEffect, useState } from 'react'
import { Table } from 'antd'
import { fetchStudentActivities } from '../../../firebase/utils'
import { Card, Container } from 'reactstrap'
import { Breadcrumbs, Btn } from '../../../AbstractElements'
import moment from 'moment'
import SeachBar from '../../UiKits/SearchBar'
import ActivityDetail from './ActivityDetail'
import { useLocation } from 'react-router'
import { addSearchParams, getSearchParams } from '../../../utils'

const StudentActivity = () => {
  const [loading, setLoading] = useState(true)
  const [search, setSearch] = useState('')
  const [activity, setActivity] = useState({
    show: false,
    details: null
  })
  const [studentActivities, setStudentActivities] = useState([])
  const location = useLocation();

  const openActivityDetails = (activity) => {
    addSearchParams(location, activity);
    setActivity({ show: true, details: activity });
  };

  const checkAndOpenDetails = () => {
    const { isOpenDetails, itemId } = getSearchParams(location);
    if (isOpenDetails && itemId) {
      const selectedItem = studentActivities.find((item) => item.id === itemId);
      if (selectedItem) {
        setActivity({ show: true, details: selectedItem });
      } else {
        setActivity({ show: false, details: null });
      }
    } else {
      setActivity({ show: false, details: null });
    }
  }

  useEffect(() => {
    checkAndOpenDetails();
  }, [location.search, studentActivities]);

  useEffect(() => {
    window.addEventListener("popstate", checkAndOpenDetails);
    return () => window.removeEventListener("popstate", checkAndOpenDetails);
  }, [studentActivities]);

  const activityTableColumn = [
    {
      title: "STUDENT EMAIL",
      dataIndex: "studentEmail",
    },
    {
      title: "TYPE",
      dataIndex: "type",
    },
    {
      title: "ACTIVITY DATE",
      dataIndex: "createdAt",
      render: (createdAt) => moment(createdAt.seconds * 1000).format('LLL')
    },
    {
      title: 'OPEN ACTVITY',
      render: (e) => <Btn attrBtn={{ color: "primary", onClick: () => openActivityDetails(e) }}>Open</Btn>
    },
  ]

  const fetchActivities = async () => {

    const reports = await fetchStudentActivities()
    setStudentActivities(reports)
    setLoading(false)
  }
  console.log("studentActivities", studentActivities)
  const filteredstudentActivities =
    studentActivities.filter((activity) => activity.studentEmail.toLowerCase().includes(search.toLowerCase()))

  useEffect(() => {
    fetchActivities()
  }, [])
  return (
    <>
      <Breadcrumbs mainTitle={'Student Activities'} />
      <Container fluid={true} className="dashboard-default">
        <Card className='p-3'>
          <div className='bug-report-search'>
            <SeachBar search={search} setSearch={setSearch} />
          </div>
          <div style={{ marginBottom: '100px' }} className='ant-design-table not-margin'>
            <Table
              loading={loading}
              columns={activityTableColumn}
              dataSource={filteredstudentActivities}
              // components={vt}
              bordered={true}
              pagination={false}

              scroll={{ y: 800 }}
            />
            {activity.show && <ActivityDetail activity={activity} setActivity={setActivity} />}
          </div>
        </Card>
      </Container>
    </>
  )
}

export default StudentActivity